<!-- Header -->
<div class="promo_band text-center">
    <div class="center-align">Sign up for your 14-day FREE Trial today!</div>
    <div class="right-align">*No Credit Card Required</div>
</div>
<header id="header" class="fc_header gray_bg sticky-top" [ngClass]="{'is-sticky': isScrolled}">
    <nav class="navbar navbar-expand-md  bg-dark navbar-light">
        <div class="container-fluid flex-md-wrap flex-lg-nowrap justify-content-md-center">
            <a class="navbar-brand" href="/">
                <img class="fc_logo" src="/assets/images/familycentral-logo.svg" width="140" height="70" alt="Family central logo">
            </a>
            <button class="navbar-toggler info_btn m-0" type="button" data-bs-toggle="collapse" data-bs-target="#fcNavbar" aria-label="Mobile menus">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse gap-3" id="fcNavbar">
                <ul class="navbar-nav me-auto">
                    <li class="nav-item">
                        <a class="nav-link" href="/aboutus">About Us</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="/how-it-works">How It Works</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/price-details">Pricing</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="/families">For Families</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link active" routerLink="/professional" >For Advisors</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/contactus">Contact Us</a>
                    </li>
                </ul>
                <div class="header_right">
                    <ul class="nav">
                        <li class="nav-item">
                            <a class="nav-link" routerLink="/login">Log in</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link primary_btn" routerLink="/signup-type">Get started</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
</header>

<style>
    .fc_header {
    padding: 0;
    width: 100%;
    z-index: 999;
    transition:.3s;
    -webkit-transition:.3s;
    -moz-transition:.3s;
    -ms-transition:.3s;
    -o-transition:.3s;
    position:sticky;
    top: 0;
    box-shadow: 0px 3.497px 17.486px 3.497px rgba(0, 0, 0, 0.11);
}
.fc_header .navbar {
    max-width: 1920px;
    margin: 0px auto;
    padding: 0 90px;
    background-color: #fff!important;
    transition:.3s;
    -webkit-transition:.3s;
    -moz-transition:.3s;
    -ms-transition:.3s;
    -o-transition:.3s;
}
.container-fluid {
    background-color: var(--white)!important;
    padding: 10px 0px;
    gap: 0 80px;
    transition: .3s;
    -webkit-transition: .3s;
    -moz-transition: .3s;
    -ms-transition: .3s;
    -o-transition: .3s;
    border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
}
.fc_header .navbar .navbar-nav {
    gap:30px;
}
.fc_header .nav-item .nav-link {
    color: var(--text_primary);
    font-weight: 600;
    font-size: clamp(16px, 1.4vw, 22px);
    padding: 10px 5px;
    transition: .2s;
    -webkit-transition: .2s;
    -moz-transition: .2s;
    -ms-transition: .2s;
    -o-transition: .2s;
}
.fc_header .nav-item .nav-link:hover, .fc_header .nav-item .nav-link.active {
    color: var(--red);
}
.header_right .nav {
    gap: 15px;
    align-items: center;
}
.fc_header .header_right .nav-item .nav-link {
    padding: 4px 0px;
    font-size: clamp(16px, 1.4vw, 22px);
}
.fc_header .nav-item .nav-link.primary_btn {
    color: var(--white);
    border: 2px solid var(--red);
    font-size: 16px !important;
    font-weight: 700;
    padding: 6px 15px!important;
}
.fc_header .nav-item .nav-link.border_btn {
    color: var(--red);
    border: 2px solid currentColor;
    padding: 4px 30px;
}
.color_logo {
    display: none;
}
/* promo banner css */
.promo_band {
  height: auto;
  background-color: var(--sky_blue);
  color: #fff;
  padding: 6px !important;
  width: 100%;
  margin-top: 0 !important;
  text-decoration: none;
  text-transform: capitalize;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.center-align {
    font-weight: 700;
    font-size: clamp(16px, 1.5vw, 22px);
    text-align: center;
}
.right-align {
    font-size: clamp(12px, 1.5vw, 18px);
    font-weight: 500;
    text-align: right;
    position: absolute;
    right: 90px;
}

@media only screen and (min-width:1440px) and (max-width:1680px) {
    .container-fluid {
        gap: 35px;
    }
    .fc_header .navbar .navbar-nav {
        gap:15px;
    }
}

@media only screen and (min-width:1201px) and (max-width:1439px) {
    .container-fluid {
        gap: 35px;
    }
    .fc_logo {width: 100px;height: auto;}
    .fc_header .navbar .navbar-nav {
        gap:15px;
    }
    .fc_header .nav-item .nav-link {font-size: clamp(15px, 1.4vw, 16px);}
    .fc_header .navbar {padding: 0 50px;}
    .fc_header .header_right .nav-item .nav-link {
        padding: 8px 0px;
    }
    .right-align {
        right: 50px;
    }
}

@media only screen and (min-width:992px) and (max-width:1200px) {
    .fc_header .navbar {padding: 0 15px;}
    .fc_header .container-fluid {gap: 0!important;padding: 10px;}
    .fc_logo {width: 100px;height: auto;}
    .fc_header .navbar-nav, .header_right .nav {gap: 10px!important;}
    .fc_header .header_right .nav-item .nav-link {
        padding: 8px 0px;
    }
    .right-align {
        right: 25px;
    }
}

@media only screen and (min-width:768px) and (max-width:991px) {
    .fc_header .navbar {padding: 0 15px;}
    .fc_header .container-fluid {gap: 0!important;padding: 10px;}
    .fc_logo {width: 100px;height: auto;}
    .header_right .nav {gap: 10px;}
    .fc_header .nav-item .nav-link {padding: 10px 4px;font-size: 14px;}
    .fc_header .nav-item .nav-link.border_btn {padding: 4px 20px;}
    .fc_header .header_right .nav-item .nav-link {padding: 10px 5px;}
    .fc_header ul.navbar-nav {gap: 0!important;}
    .right-align {
        right: 25px;
    }
}

@media only screen and (max-width:767px) {
    .fc_header, .fc_header .navbar {padding: 0;position: sticky;}
    img.fc_logo {width: 100px;height: auto;}
    .fc_header .navbar-nav {gap: 0!important;}
    .header_right .nav {gap: 15px;flex-direction: column;padding: 10px 0 20px;align-items: flex-start;}
    .fc_header .container-fluid {padding: 5px 15px;}
    .fc_header .header_right .nav-item .nav-link {padding: 5px 5px;}
    .fc_header .navbar-collapse {border-top: 1px solid rgba(255,255,255,0.3);}
    .fc_header.is-sticky {padding: 0;}
    .promo_band {
        display: block;
        font-size: 14px;
        padding: 6px 15px !important;
        line-height: 18px;
    }
    .right-align {
        text-align: center;
        position: relative;
        right: auto;
        display: block;
    }
}
</style> 